import React from 'react';
import { CheckCircle2Icon, TargetIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-349" data-mp="185gecasyuarb">
      <div className="mx-auto max-w-3xl" data-id="element-350" data-mp="1c6a1v32hxnjo">
        <div id="volumes-title" data-id="element-351" data-mp="1zv1n1aho55my">
          <SectionHeading eyebrow="What’s inside" title={<>6 Volumes That Follow a <span className="italic text-gold" data-id="element-353" data-mp="24ue7xpozc2mw">Logical Planning Workflow</span></>} intro="From the initial organization of a case to the final treatment roadmap. Work through the full system or return to individual tools when you need them." data-id="element-352" data-mp="1zutajjpgk2ca" />
        </div>

        <ol className="mt-10 space-y-5" data-id="element-354" data-mp="ffhjtzw05lf9">
          {volumes.map(v => <li key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-navy/10" data-id="element-355" data-mp="fhaoxaqyvxl5">
              <div className="flex items-center gap-4 bg-navy px-5 py-4" data-id="element-356" data-mp="3o86nygk2q0ap">
                <span className="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-xl border border-gold bg-navy-light" data-id="element-357" data-mp="3o8expzkwgpho">
                  <span className="text-[9px] font-bold uppercase tracking-widest text-gold-light" data-id="element-358" data-mp="21htib0dzhj7">Vol</span>
                  <span className="font-serif text-xl font-extrabold leading-none text-gold-light" data-id="element-359" data-mp="3t7028b76pvbx">{v.number}</span>
                </span>
                <h3 className="font-serif text-lg font-bold leading-snug text-white sm:text-xl" data-id="element-360" data-mp="b0238mnyygva">{v.title}</h3>
              </div>
              <div className="p-5 sm:p-7" data-id="element-361" data-mp="60phk58u3fua">
                <p className="font-serif text-lg font-bold italic text-gold" data-id="element-362" data-mp="kqeq4lj9am4l">{v.subtitle}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-363" data-mp="fs3huf8m0joh">{v.intro}</p>
                <ul className="mt-4 space-y-2" data-id="element-364" data-mp="trcvb75fkzor">
                  {v.bullets.map(b => <li key={b} className="flex gap-2.5 text-[15px] leading-snug text-navy" data-id="element-365" data-mp="pr2oxtdq879d">
                      <CheckCircle2Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-cta" data-id="element-366" data-mp="wu98wmkjavju" />
                      <span data-id="element-367" data-mp="11sarl6e1ssus">{b}</span>
                    </li>)}
                </ul>
                <p className="mt-5 flex gap-2.5 rounded-xl bg-gold-pale px-4 py-3 text-sm font-semibold leading-snug text-navy" data-id="element-368" data-mp="16rncvmp9trv9">
                  <TargetIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-369" data-mp="1bk6pohg4wiz0" />
                  <span data-id="element-370" data-mp="1fjflrsyncsxq">{v.outcome}</span>
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mt-8 text-center text-xs leading-relaxed text-ink-muted" data-id="element-371" data-mp="1klenkyeqnhsk">
          The frameworks help you organize your reasoning; they don’t automatically determine the appropriate clinical approach
          for an individual patient.
        </p>

        <div className="mt-10" data-id="element-372" data-mp="3rat9m2uknexg">
          <CtaButton label="I Want All 6 Volumes" data-id="element-373" data-mp="3rbm68aztgo1v" />
        </div>
      </div>
    </section>;
}